// extracted by mini-css-extract-plugin
module.exports = {"popOver":"style_popOver__3Q3Uq","cardstyle":"style_cardstyle__3Alc0","dropdown":"style_dropdown__2qPTz","avatar":"style_avatar__1kep5","menuIcon":"style_menuIcon__2j7O1"};